module.exports = __webpack_public_path__ + "static/media/gallery-bg.0de0ce98.jpg";